module.exports = __webpack_public_path__ + "assets/photos/memories/frame-5-mobile--13c0b7662a3cd584a8f2964c52a7998e.jpg";